import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import CommunitiesComponent from "../components/communities/communities.components"

const Communities = () => {
  return (
    <Layout>
      <CommunitiesComponent />
    </Layout>
  )
}

export default Communities

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
